/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else { len += 0.5 }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  const paramObj = JSON.parse('{"' + (search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
  Object.keys(paramObj).map(key => {
    paramObj[key] = decodeURIComponent(paramObj[key])
  })
  return paramObj
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
   giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  for (const property in source) {
    if (source.hasOwnProperty(property)) {
      const sourceProperty = source[property]
      if (typeof sourceProperty === 'object') {
        target[property] = objectMerge(target[property], sourceProperty)
        continue
      }
      target[property] = sourceProperty
    }
  }
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {}
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    }
  }
  return targetObj
}

/**
* HSL颜色值转换为RGB
* H，S，L 设定在 [0, 1] 之间
* R，G，B 返回在 [0, 255] 之间
*
* @param H 色相
* @param S 饱和度
* @param L 亮度
* @returns Array RGB色值
*/
export function hslToRgb(H, S, L) {
  let R, G, B
  if (+S === 0) {
    R = G = B = L // 饱和度为0 为灰色
  } else {
    const hue2Rgb = function(p, q, t) {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < 1 / 6) return p + (q - p) * 6 * t
      if (t < 1 / 2) return q
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
      return p
    }
    const Q = L < 0.5 ? L * (1 + S) : L + S - L * S
    const P = 2 * L - Q
    R = hue2Rgb(P, Q, H + 1 / 3)
    G = hue2Rgb(P, Q, H)
    B = hue2Rgb(P, Q, H - 1 / 3)
  }
  return [Math.round(R * 255), Math.round(G * 255), Math.round(B * 255)]
}

// 获取随机HSL
export function randomHsl(seed) {
  const rgb = []
  Math.seed = seed
  Math.seededRandom = function(max, min) {
    max = max || 1
    min = min || 0
    Math.seed = (Math.seed * 9301 + 49297) % 233280
    const rnd = Math.seed / 233280.0
    return min + rnd * (max - min)
  }

  for (let i = 0; i < 3; i++) {
    rgb.push(Math.seededRandom())
  }

  return rgb
}

// 获取HSL数组
export function getHslArray(hslLength) {
  const HSL = []
  for (let i = 0; i <= hslLength.length - 1; i++) {
    // 不处理其他
    if (hslLength[i] === '1011') {
      HSL.push([245, 247, 250])
      continue
    }
    let ret = randomHsl(hslLength[i])
    // let ret = hslLength[i] === '1011' ? [0, 0, 0] : randomHsl(hslLength[i])
    // 暂时保留注释代码
    // 颜色相邻颜色差异须大于 0.25
    // if (i > 0 && Math.abs(ret[0] - HSL[i - 1][0]) < 0.25) {
    //   i--
    //   continue // 重新获取随机色
    // }
    if (hslLength[i] !== '1011') {
      ret[1] = 0.7 + (ret[1] * 0.2) // [0.7 - 0.9] 排除过灰颜色
      ret[2] = 0.4 + (ret[2] * 0.4) // [0.4 - 0.8] 排除过亮过暗色
    }

    // 数据转化到小数点后两位
    ret = ret.map(item => parseFloat(item.toFixed(2)))

    HSL.push(ret)
  }
  return HSL.map((item, index) => {
    // 其他的直接返回
    if (hslLength[index] === '1011') {
      return item
    } else {
      return hslToRgb.apply(this, item)
    }
  })
}

/**
 * 属性结构排序
 * @param {*} tree
 * @param {*} childrenKey children
 */
export function sortTree(tree, childrenKey = 'children') {
  if (tree && tree.length) {
    const compare = (item1, item2) => {
      const sort1 = item1.sort || 0
      const sort2 = item2.sort || 0
      if (sort1 > sort2) {
        return 1
      } else if (sort1 < sort2) {
        return -1
      } else {
        return 0
      }
    }
    const checkout = list => {
      if (list.length) {
        list.sort(compare).forEach(item => {
          if (item.children) {
            checkout(item.children)
          }
        })
      }
    }
    checkout(tree)
  }

  // return new Promise((resolve, reject) => {
  //   if (tree && tree.length) {
  //     const compare = (item1, item2) => {
  //       const sort1 = item1.sort || 0
  //       const sort2 = item2.sort || 0
  //       if (sort1 > sort2) {
  //         return 1
  //       } else if (sort1 < sort2) {
  //         return -1
  //       } else {
  //         return 0
  //       }
  //     }
  //     const checkout = list => {
  //       if (list.length) {
  //         list.sort(compare).forEach(item => {
  //           if (item.children) {
  //             checkout(item.children)
  //           }
  //         })
  //       }
  //     }
  //     checkout(tree)

  //     setTimeout(() => {
  //       resolve(tree)
  //     }, 0)
  //   } else {
  //     resolve()
  // }
  // })
}

/**
 * 树形数组转列表
 * @param {*} list 属性结构数据
 * @param {*} childrenKey 默认 children
 * @returns
 */
export function treeTolist(list, childrenKey = 'children') {
  const unfoldTree = [] //  展开属性结构的数据

  // 每次展开（当局部刷新之后关心这个）
  const recursionChild = list => {
    if (list && list.length) {
      for (let index = 0; index < list.length; index++) {
        const item = list[index]
        unfoldTree.push(item)
        if (item[childrenKey] && item[childrenKey].length) {
          recursionChild(item[childrenKey])
        }
      }
    }
  }
  recursionChild(list)

  return unfoldTree
}

/**
 * 获取总数
 * @param {*} arr list
 * @param {*} keyName list的key
 * @returns
 */
export function countTotal(arr, keyName) {
  let _total = 0
  _total = JSON.parse(JSON.stringify(arr)).reduce((total, currentValue, currentIndex, arr) => currentValue[keyName] ? total + currentValue[keyName] : total, 0)
  return _total
}

/**
 * 数组去重
 * @param {*} arr 要使用的数组
 * @param {*} key 数组的key值
 * @returns 返回去重复后的数据 [key,key,key]
 */
export function unique(arr, key) {
  const obj = {}
  // 防止改变原有数据
  return JSON.parse(JSON.stringify(arr)).reduce((cur, next) => {
    obj[next[key]] ? '' : obj[next[key]] = true && cur.push(next)
    return cur
  }, []).map(item => item[key]) // 设置cur默认类型为数组，并且初始值为空的数组
}
